import { Link } from "react-router-dom";
import { BrandImageStyledContainer, BrandImageStyledComponent } from "./brand-image.style";

export const BrandImage = ({ width }) => {
   return (
      <BrandImageStyledContainer width={width}>
         <Link to="/">
            <BrandImageStyledComponent src="/assets/images/lendsqr-logo.png" alt="brand image" />
         </Link>
      </BrandImageStyledContainer>
   );
};
